import { render } from "./ViewJob.vue?vue&type=template&id=53f394b0&scoped=true"
import script from "./ViewJob.vue?vue&type=script&lang=js"
export * from "./ViewJob.vue?vue&type=script&lang=js"

import "./ViewJob.vue?vue&type=style&index=0&id=53f394b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f394b0"]])

export default __exports__